import React, { useState } from 'react';
import Button from '../Button';
import Dialog from './Dialog';
import ShipmentSearchPicker from './ShipmentSearchPicker';
import { Banner } from './Ui';

// Merge this shipment INTO another one: its e-mails and events move to the target, this one becomes a redirect.
const MergeDialog = ({ shipmentId, onClose, onMerge }) => {
  const [target, setTarget] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async () => {
    setBusy(true);
    setError('');
    try { await onMerge(target); } catch (err) { setError(err.message); setBusy(false); }
  };

  return (
    <Dialog
      title="Sloučit zásilku" busy={busy} onClose={onClose}
      footer={(
        <>
          <Button variant="secondary" onClick={onClose} disabled={busy}>Zrušit</Button>
          <Button disabled={!target} loading={busy} onClick={submit}>Sloučit do vybrané zásilky</Button>
        </>
      )}
    >
      <div style={{ paddingBottom: 8 }} className="shp-stack">
        <p className="shp-muted" style={{ fontSize: 14, margin: 0 }}>
          E-maily a události této zásilky se přesunou do zásilky, kterou vyberete. Tato zásilka zůstane jen jako odkaz na ni.
        </p>
        {error && <Banner tone="bad">{error}</Banner>}
        <ShipmentSearchPicker excludeId={shipmentId} value={target} onChange={setTarget} />
      </div>
    </Dialog>
  );
};

export default MergeDialog;
